import ApiCaller from '../ApiCaller';
import baseConfig from 'actions/BaseAjaxConfig';
export var orderIssueActionsEnum;
(function (orderIssueActionsEnum) {
    orderIssueActionsEnum["GET_ORDER_ISSUES_REQUEST"] = "GET_ORDER_ISSUES_REQUEST";
    orderIssueActionsEnum["GET_ORDER_ISSUES_SUCCESS"] = "GET_ORDER_ISSUES_SUCCESS";
    orderIssueActionsEnum["GET_ORDER_ISSUES_ERROR"] = "GET_ORDER_ISSUES_ERROR";
    orderIssueActionsEnum["RESET_ORDER_ISSUES"] = "RESET_ORDER_ISSUES";
    orderIssueActionsEnum["SET_CURRENT_ITEM"] = "SET_CURRENT_ITEM";
})(orderIssueActionsEnum || (orderIssueActionsEnum = {}));
export function fetchOrderIssues({ orderId, orderItemId, orderItemState, title, unitId }) {
    return (dispatch) => {
        dispatch({
            type: orderIssueActionsEnum.GET_ORDER_ISSUES_REQUEST,
            data: { orderId, orderItemId, orderItemState, title, unitId }
        });
        const pathname = '/api/1/self-serve/helpcenter/orderedIssues';
        const query = {
            orderItemState,
            orderId,
            itemId: unitId,
            unitId: orderItemId
        };
        return ApiCaller.get(Object.assign({}, baseConfig, {
            pathname,
            query,
            action: orderIssueActionsEnum.GET_ORDER_ISSUES_REQUEST
        })).then(data => {
            dispatch({
                type: orderIssueActionsEnum.GET_ORDER_ISSUES_SUCCESS,
                data: data.RESPONSE,
                orderIssueItem: orderItemId
            });
        }, error => {
            dispatch({ type: orderIssueActionsEnum.GET_ORDER_ISSUES_ERROR, error });
        });
    };
}
export function resetOrderIssues() {
    return (dispatch) => {
        dispatch({ type: orderIssueActionsEnum.RESET_ORDER_ISSUES });
    };
}
export const setCurrentItem = item => {
    return (dispatch) => {
        dispatch({
            type: orderIssueActionsEnum.SET_CURRENT_ITEM,
            item
        });
    };
};
